export default "__VITE_ASSET__DBTmF0fD__"